import React, { useEffect, useContext, useState, useRef } from 'react'
import { FOND_BANDE_BASSE } from "../Formats/FormatsHelpers"
import { debounce } from 'lodash';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box } from '@mui/material'

import completedFormatIcon from '../../../images/completedFormatIcon.svg'
import playVideoIcon from '../../../images/playVideoIcon.svg'


/* `videoCouverture` (06/10/2026, vignette du module en cours du tableau de
   bord, demande de Nawal) : l'identifiant Mux d'une video. A la place de
   l'ECRAN en reduction (ou la video n'occupait qu'un petit rectangle au
   milieu de marges grises), la vignette de la video remplit le cadre, en
   `cover` (leger recadrage, jamais de deformation, centree), bouton de lecture
   au centre, sans voile gris. Le cadre lui-meme ne change pas : meme boite,
   meme rapport, meme calcul de taille. Optionnel : les autres emplois de ce
   composant (plan de cours, editeur) ne le passent pas et ne changent pas. */
const ScaleThumbForm = ({ onClick, completedIcon, isEditor, grabCursor, children , fond, videoCouverture }) => {

  const [scale, setScale] = useState(0)

  const theme = useTheme();
  const mediaQueryUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const observedElementRef = useRef(null)
  useEffect(() => {
    if (observedElementRef.current) {
      const observer = new ResizeObserver(debounce((entries) => {
        for (let entry of entries) {
          let width = observedElementRef.current?.getBoundingClientRect()?.width
          let height = observedElementRef.current?.getBoundingClientRect()?.height

          let widthToGo = 600
          if (mediaQueryUpSm) {
            widthToGo = 1500
          }

          let newScale = width/widthToGo
          setScale(newScale)
        }
      }));
      observer.observe(observedElementRef?.current);
      return () => {
          observer.disconnect();
      };
    }
  }, [observedElementRef?.current, mediaQueryUpSm]);

  return (
    <Box
      ref={observedElementRef}
      sx={{
        aspectRatio:"1.5",
        flex:1,
        overflow:"hidden",
        position:"relative",
        cursor:grabCursor ? "grab" : onClick?"pointer":"default",
      }}
      onClick={onClick?onClick:null}
    >
      <Box sx={{
        width:["600px", "1500px"],
        height:["400px", "1000px"],
        transform:"scale("+scale+")",
        transformOrigin:"top left",
        /* Lot G : la vignette porte le fond de l'ECRAN qu'elle montre, pas un
           fond de vignette. Sans cela, un ecran blanc chez l'apprenant
           apparaissait teinte dans le plan de cours et dans l'editeur.
           ⚠️ Fidele, pas identique : hors editeur, un voile rgba(0,0,0,0.1) est
           peint par-dessus quelques lignes plus bas. On passe donc de
           « #FAF8F6 voile » a « #FFFFFF voile », ce qui rapproche du rendu
           apprenant sans l'atteindre. */
        backgroundColor: fond || FOND_BANDE_BASSE
      }}>
        {videoCouverture ? null : children}
      </Box>
      {videoCouverture &&
        <Box data-vignette-video sx={{
          position:"absolute",
          top:0, left:0, width:"100%", height:"100%",
          backgroundColor:"#0A0A0B",
          backgroundImage:"url('https://image.mux.com/" + videoCouverture + "/thumbnail.png?width=1280&height=720&fit_mode=crop')",
          backgroundSize:"cover",
          backgroundPosition:"center center",
          backgroundRepeat:"no-repeat",
          display:"flex",
          alignItems:"center",
          justifyContent:"center",
        }}>
          <Box sx={{ width:["48px", "64px", "64px", "64px"], userSelect:"none", pointerEvents:"none" }}>
            <img src={playVideoIcon} alt="" style={{ width:"100%", display:"block" }} />
          </Box>
        </Box>
      }
      {!isEditor && !videoCouverture &&
        <Box sx={{
          background:"rgba(0,0,0,0.1)",
          width:"100%",
          height:"100%",
          position:"absolute",
          top:0,
          left:0,
        }} />
      }
      {completedIcon &&
        <Box sx={{
          width:"100%",
          height:"100%",
          position:"absolute",
          top:0,
          left:0,
          display:"flex",
          justifyContent:["center", "center", "flex-end"],
          alignItems:["center", "center", "flex-start"],
          padding:["0", "0", "10px"],
          userSelect:"none",
        }}>
          <Box
            sx={{
              width:["20px", "20px", "25px"],
              minWidth:["20px", "20px", "25px"],
            }}
          >
            <img
              src={completedFormatIcon}
              style={{width:"100%"}}
            />
          </Box>
        </Box>
      }
    </Box>
  )
}

export default ScaleThumbForm
